import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5000/api';

/**
 * Fetch all reviews for a business
 * @param {string} businessType - 'Shop', 'Restaurant', or 'Task'
 * @param {string} businessId - MongoDB ObjectId of business
 * @param {string} token - Partner auth token
 */
export const fetchReviews = async (businessType, businessId, token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.get(
    `${BASE_URL}/review/${businessType}/${businessId}`,
    { headers }
  );
  return response.data;
};

/**
 * Submit or update a reply to a review
 * @param {string} reviewId - MongoDB ObjectId of the review
 * @param {string} comment - Reply text content
 * @param {string} token - Partner auth token
 */
export const submitReviewReply = async (reviewId, comment, token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.put(
    `${BASE_URL}/review/${reviewId}/reply`,
    { comment },
    { headers }
  );
  return response.data;
};

/**
 * Delete a partner reply from a review
 * @param {string} reviewId - MongoDB ObjectId of the review
 * @param {string} token - Partner auth token
 */
export const deleteReviewReply = async (reviewId, token) => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const response = await axios.delete(
    `${BASE_URL}/review/${reviewId}/reply`,
    { headers }
  );
  return response.data;
};
